/**
 * Format file size from bytes to a human-readable string representation.
 * @param {number} bytes - The size in bytes to be formatted.
 * @returns {string} A string representing the formatted file size (e.g., '1 KB', '2.5 MB').
 */
export const formatFileSize = (bytes: number): string => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];

  if (bytes <= 0) {
    return '0 B';
  }

  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = bytes / Math.pow(1024, i);

  return `${size.toFixed(0)} ${units[i]}`;
};
